import React from "react";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import TabbedHeader from "../../../../Utils/layout/components/header/TabbedHeader/TabbedHeader";
import * as helpers from "../../../util/helpers";
import { useMobileViewport } from "../../../util/mobileViewPort";
import { setSettingsPageTabIndex } from "../../Settings/state/slices/campaignSlice";

const configurationTabLabelsMap = {
  settings: "Settings",
  account_profile: "Profile",
  invoices: "Invoices",
  billing_summary: "Billing Summary",
  history: "History",
  payments: "Payments & Plans",
  billstatement: "Bill Statement",
};

const MyAccountHeader = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const selectedTab = useSelector((state) => state.campaignSlice.activeTab);

  const settingsTabPaths = [
    ...((helpers.isAccountSettingsEnabled() && ["settings"]) || []),
    ...((helpers.isFeatureEnabledProfile('international_user') && ["account_profile"]) || []),
    ...((helpers.isAccountInvoicesEnabled() && ["invoices"]) || []),
    ...((helpers.isAccountBillingSummaryEnabled() && ["billing_summary"]) || []),
    ...((helpers.isAccountHistoryEnabled() && ["history"]) || []),
    ...((helpers.isPaymentsTabEnabled() && ["payments"]) || []),
    ...((false && ["billstatement"]) || []),
  ];

  const splitLocationPathname = useCallback(() => {
    return location.pathname.split("/")[1];
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname) {
      Object.keys(settingsTabPaths).forEach((path, index) => {
        if (configurationTabLabelsMap[splitLocationPathname()]) {
          if (splitLocationPathname() === settingsTabPaths[index]) {
            handleOnTabChange(null, index);
          } else {
            if (!settingsTabPaths.includes(splitLocationPathname())) {
              history.push(`/`);
            }
          }
        }
      });
    }
  }, [splitLocationPathname]);

  const handleOnTabChange = (event, newValue) => {
    dispatch(setSettingsPageTabIndex(newValue));
    history.push(`/${settingsTabPaths[newValue]}`);
  };

  return (
    <div className="d-flex flex-grow-1">
      {!useMobileViewport() && (
        <TabbedHeader
          value={selectedTab}
          ariaLabel="settings"
          handleChange={handleOnTabChange}
          tabList={[
            ...((helpers.isAccountSettingsEnabled() && ["Settings"]) || []),
            ...((helpers.isFeatureEnabledProfile('international_user') && ["Profile"]) || []),
            ...((helpers.isAccountInvoicesEnabled() && ["Invoices"]) || []),
            ...((helpers.isAccountBillingSummaryEnabled() && ["Billing Summary"]) || []),
            ...((helpers.isAccountHistoryEnabled() && ["History"]) || []),
            ...((helpers.isPaymentsTabEnabled() && ["Payments & Plans"]) || []),
            ...((false && ["Bill Statement"]) || []),
          ]}
        />
      )}
    </div>
  );
};

export default MyAccountHeader;
